import { render, staticRenderFns } from "./Sourses.vue?vue&type=template&id=5072282a&"
import script from "./Sourses.vue?vue&type=script&lang=js&"
export * from "./Sourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports